const lazyLoading = () => {
    // Initialize app globally first
    window.app = window.app || {};
    
    // Handle fade-in animation for loaded images
    const addLoadedClass = (img) => {
        img.classList.add('loaded');
    };
    
    // Handle image load events for fade-in animation
    const handleImageLoad = (img) => {
        if (img.complete) {
            addLoadedClass(img);
        } else {
            img.addEventListener('load', () => addLoadedClass(img));
            img.addEventListener('error', () => addLoadedClass(img)); // Still fade in on error
        }
    };
    
    // Initialize all lazy loaded images
    const initLazyImages = () => {
        // Handle native lazy loading images (exclude LCP images with fetchpriority="high")
        const nativeLazyImages = document.querySelectorAll('img[loading="lazy"]:not([fetchpriority="high"])');
        nativeLazyImages.forEach(handleImageLoad);
        
        // Handle fallback data-src images (for older browsers)
        const fallbackImages = document.querySelectorAll('img[data-src]');
        fallbackImages.forEach(img => {
            if (img.src === '' || img.src.includes('data:image/png;base64')) {
                img.src = img.dataset.src;
                img.removeAttribute('data-src');
            }
            handleImageLoad(img);
        });
    };
    
    // Legacy blazy migration - convert b-lazy to native lazy loading
    window.app.migrateBlazy = function () {
        const blazyImages = document.querySelectorAll('img.b-lazy');
        blazyImages.forEach(img => {
            if (img.dataset.src) {
                img.src = img.dataset.src;
                img.classList.remove('b-lazy');
                img.removeAttribute('data-src');
                img.setAttribute('loading', 'lazy');
                handleImageLoad(img);
            }
        });
        
        // Handle div elements with b-lazy class (background images)
        const blazyDivs = document.querySelectorAll('div.b-lazy');
        blazyDivs.forEach(div => {
            if (div.dataset.src) {
                div.style.backgroundImage = `url(${div.dataset.src})`;
                div.classList.remove('b-lazy');
                div.removeAttribute('data-src');
                addLoadedClass(div);
            }
        });
        
        // Handle elements with data-bg-image attribute (for dynamically loaded content)
        const bgImageElements = document.querySelectorAll('[data-bg-image]');
        bgImageElements.forEach(element => {
            const bgImage = element.getAttribute('data-bg-image');
            if (bgImage && !element.style.backgroundImage) {
                element.style.backgroundImage = `url(${bgImage})`;
                addLoadedClass(element);
            }
        });
        
        // Handle native lazy loading images that are dynamically added (for load more functionality)
        const nativeLazyImages = document.querySelectorAll('img[loading="lazy"]:not([fetchpriority="high"])');
        nativeLazyImages.forEach(img => {
            // Only handle images that haven't been processed yet (no 'loaded' class)
            if (!img.classList.contains('loaded')) {
                handleImageLoad(img);
            }
        });
    };
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initLazyImages);
    } else {
        initLazyImages();
    }
    
    // Migrate any remaining blazy elements
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            setTimeout(window.app.migrateBlazy, 100);
        });
    } else {
        setTimeout(window.app.migrateBlazy, 100);
    }
};

export default lazyLoading;
